import { render, staticRenderFns } from "./set-fail.vue?vue&type=template&id=894af608&scoped=true"
import script from "./set-fail.vue?vue&type=script&lang=js"
export * from "./set-fail.vue?vue&type=script&lang=js"
import style0 from "./set-fail.vue?vue&type=style&index=0&id=894af608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894af608",
  null
  
)

export default component.exports